import React, { FunctionComponent, useRef, useState } from 'react'
import styles from './TaskFilters.module.sass'
import {
    Brand,
    ClientWithBrands,
    DirectionWithDepartments,
    TaskType
} from '../../../../../responses/refs/refs'
import { useRipple } from 'react-use-ripple'
import ChevronDownIcon from 'files/chevron/down.svg'
import clsx from 'clsx'
import { Classes} from '../../../../../styles'
import { motion } from 'framer-motion'
import {useRootDispatch, useRootSelector} from '../../../../../utils/hooks'
import Button from '../../../../controls/Button/Button'
import {taskFiltersActions} from '../../../../../redux/pages/task-list/TaskFilters'
import FiltersClearIcon from '../../../../../../files/filters-clear.svg'
import ThreeLevelDropdown from '../../../../data-components/dropdowns/ThreeLevelDropdown/ThreeLevelDropdown'
import {Departments} from '../../../../../responses/departments'
import {User} from '../../../../../responses/users'
import {apiRequests} from '../../../../../http/config'
import {flow} from 'fp-ts/function'
import TwoLevelDropdown from '../../../../data-components/dropdowns/TwoLevelDropdown/TwoLevelDropdown'
import RequestDropdown from '../../../../data-components/dropdowns/RequestDropdown/RequestDropdown'
import {WorkObject} from '../../../../../responses/objects'
function addDirectionLS(e:any) {// eslint-disable-line
    window.localStorage.setItem('TF_direction', JSON.stringify(e.payload))
}
function addDepartmentLS(e:any) {// eslint-disable-line
    window.localStorage.setItem('TF_department', JSON.stringify(e.payload))
}
function addUserLS(e:any) {// eslint-disable-line
    window.localStorage.setItem('TF_user', JSON.stringify(e.payload))
}
function addClientLS(e:any) {// eslint-disable-line
    window.localStorage.setItem('TF_client', JSON.stringify(e.payload))
}
function addBrandLS(e:any) {// eslint-disable-line
    window.localStorage.setItem('TF_brand', JSON.stringify(e.payload))
}
function addWorkObjectLS(e:any) {// eslint-disable-line
    window.localStorage.setItem('TF_work_object', JSON.stringify(e.payload))
}
function addTasksTypeLS(e:any) {// eslint-disable-line
    window.localStorage.setItem('TF_tasks_type', JSON.stringify(e.payload))
}
function clearFilterLS() {
    window.localStorage.removeItem('TF_direction')
    window.localStorage.removeItem('TF_department')
    window.localStorage.removeItem('TF_user')
    window.localStorage.removeItem('TF_client')
    window.localStorage.removeItem('TF_brand')
    window.localStorage.removeItem('TF_work_object')
    window.localStorage.removeItem('TF_tasks_type')
}

const TaskFiltersMobile: FunctionComponent = () => {
    const dispatch = useRootDispatch()

    //const directions = useRootSelector(state=>state.pages.taskFilters.direction)
    //const departments = useRootSelector(state=>state.pages.taskFilters.department)
    //const users = useRootSelector(state=>state.pages.taskFilters.user)
    //const clients = useRootSelector(state => state.pages.taskFilters.client)
    //const brands = useRootSelector(state => state.pages.taskFilters.brand)
    //const workObject = useRootSelector(state => state.pages.taskFilters.work_object)
    //const tasksTypes = useRootSelector(state => state.pages.taskFilters.tasks_type)

    const directions = useRootSelector(state=>{
        if(window.localStorage.getItem('TF_direction')) {
            const x:any = window.localStorage.getItem('TF_direction') ? window.localStorage.getItem('TF_direction') : '' // eslint-disable-line
            return JSON.parse(x)
        } else {
            return state.pages.taskFilters.direction
        }
    })

    const departments = useRootSelector(state=>{
        if(window.localStorage.getItem('TF_department')) {
            const x:any = window.localStorage.getItem('TF_department') ? window.localStorage.getItem('TF_department') : '' // eslint-disable-line
            return JSON.parse(x)
        } else {
            return state.pages.taskFilters.department
        }
    })

    const users = useRootSelector(state=>{
        if(window.localStorage.getItem('TF_user')) {
            const x:any = window.localStorage.getItem('TF_user') ? window.localStorage.getItem('TF_user') : '' // eslint-disable-line
            return JSON.parse(x)
        } else {
            return state.pages.taskFilters.user
        }
    })

    const clients = useRootSelector(state=>{
        if(window.localStorage.getItem('TF_client')) {
            const x:any = window.localStorage.getItem('TF_client') ? window.localStorage.getItem('TF_client') : '' // eslint-disable-line
            return JSON.parse(x)
        } else {
            return state.pages.taskFilters.client
        }
    })

    const brands = useRootSelector(state=>{
        if(window.localStorage.getItem('TF_brand')) {
            const x:any = window.localStorage.getItem('TF_brand') ? window.localStorage.getItem('TF_brand') : '' // eslint-disable-line
            return JSON.parse(x)
        } else {
            return state.pages.taskFilters.brand
        }
    })
    const workObject = useRootSelector(state=>{
        if(window.localStorage.getItem('TF_work_object')) {
            const x:any = window.localStorage.getItem('TF_work_object') ? window.localStorage.getItem('TF_work_object') : '' // eslint-disable-line
            return JSON.parse(x)
        } else {
            return state.pages.taskFilters.work_object
        }
    })


    const tasksTypes = useRootSelector(state => {
        if(window.localStorage.getItem('TF_tasks_type')) {
            const x:any = window.localStorage.getItem('TF_tasks_type') ? window.localStorage.getItem('TF_tasks_type') : '' // eslint-disable-line
            return JSON.parse(x)
        } else {
            return state.pages.taskFilters.tasks_type
        }
    })

    const [open, setOpen] = useState(false)
    const headerRef = useRef(null)
    useRipple(headerRef)

    return <div className={styles.mobile}>
        <div ref={headerRef} className={styles.header} onClick={() => setOpen(!open)}>
            <span className={styles.text}>Задачи по отделам</span>
            <ChevronDownIcon className={clsx({open: Classes.flip})}/>
        </div>
        <motion.div
            className={styles.content}
            initial={{height: 0}}
            animate={{height: open? '50vh': 0}}
        >
            <Button
                title={'Очистить фильтры'}
                onClick={() => {
                    dispatch(taskFiltersActions.clearFilters())
                    clearFilterLS()
                }}
            >
                <FiltersClearIcon/>
            </Button>
            <ThreeLevelDropdown<DirectionWithDepartments, Departments, User>
                className={clsx(styles.dropdown,styles.mxw300)}
                placeholder={'Направление/Отдел/Сотрудник'}
                selection={directions}
                subselection={departments}
                subsubselection={users}
                render={direction => direction.title}
                subRender={department => department.title}
                subsubRender={user => user.name}
                selector={direction => direction.departments}
                subselector={department => department.users}
                request={query => apiRequests.dictionary.directionList({
                    query: {limit:query.limit, offset:query.offset, search_full: query.search}
                })}
                onSelectionChange={flow(taskFiltersActions.setDirections, dispatch, addDirectionLS)}
                onSubselectionChange={flow(taskFiltersActions.setDepartments, dispatch, addDepartmentLS)}
                onSubsubselectionChange={flow(taskFiltersActions.setUsers, dispatch, addUserLS)}
            />
            <TwoLevelDropdown<ClientWithBrands, Brand>
                className={clsx(styles.dropdown,styles.mxw200)}
                placeholder={'Клиент/Бренд'}
                selection={clients}
                subselection={brands}
                render={client => client.short_title}
                subRender={brand => brand.title}
                selector={client => client.brands}
                request={query => apiRequests.dictionary.list({
                    query,
                    params: {key: 'client'}
                })}
                onSelectionChange={flow(taskFiltersActions.setClients, dispatch, addClientLS)}
                onSubselectionChange={flow(taskFiltersActions.setBrands, dispatch, addBrandLS)}
            />
            <RequestDropdown<WorkObject>
                className={clsx(styles.dropdown,styles.mxw150)}
                render={workObject => workObject.name}
                type={'multi'}
                placeholder={'Тип объекта'}
                request={query => apiRequests.project.tipWorkObject({
                    query: query
                })}
                value={workObject ? workObject : []}
                onChange={ flow(taskFiltersActions.setWorkObjects, dispatch, addWorkObjectLS)}
            />
            <RequestDropdown<TaskType>
                className={clsx(styles.dropdown,styles.mxw150)}
                render={task => task.name}
                type={'multi'}
                placeholder={'Тип задачи'}
                request={query => apiRequests.project.tipTaskType({
                    query: query
                })}
                value={tasksTypes ? tasksTypes : []}
                //onChange={ flow(taskFiltersActions.setTasksType, dispatch)}
                onChange={ flow(taskFiltersActions.setTasksType, dispatch, addTasksTypeLS)}
            />
        </motion.div>
    </div>
}

export default TaskFiltersMobile